<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg2940"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs2944"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2954"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2952" /></clipPath></defs><g
     id="g2946"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g2948"><g
         id="g2950"
         clip-path="url(#clipPath2954)"><g
           id="g2956"
           transform="translate(454,336.1699)"><path
             d="m 0,0 h 35.5 c 8.28,0 15,-6.72 15,-15 v -257.81 c 0,-8.29 -6.72,-15 -15,-15 H -198 -431.5 c -8.28,0 -15,6.71 -15,15 V -15 c 0,8.28 6.72,15 15,15 h 35.5"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2958" /></g><g
           id="g2960"
           transform="translate(454,166.3662)"><path
             d="m 0,0 v -66.008 c 0,-3.866 -3.134,-7 -7,-7 h -121.817 c -29.93,0 -57.049,-17.639 -69.183,-45 v 276 c 0,27.614 22.386,50 50,50 H -7 c 3.866,0 7,-3.135 7,-7 V 35"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2962" /></g><g
           id="g2964"
           transform="translate(65,93.3584)"><path
             d="m 0,0 h 121.817 c 29.93,0 57.049,-17.64 69.183,-45 v 276 c 0,27.614 -22.386,50 -50,50 H 0 c -3.866,0 -7,-3.135 -7,-7 V 7 C -7,3.134 -3.866,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2966" /></g><g
           id="g2968"
           transform="translate(169.2842,417.1553)"><path
             d="m 0,0 h -83.499 l -22.857,17.71 c -3.618,2.802 -3.618,8.265 0,11.066 l 22.857,17.71 h 356 c 5.523,0 10,-4.476 10,-10 V 10 c 0,-5.523 -4.477,-10 -10,-10 L 35,0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2970" /></g><g
           id="g2972"
           transform="translate(406.7852,417.1553)"><path
             d="m 0,0 v 46.486 h 35 c 5.523,0 10,-4.476 10,-10 V 10 C 45,4.477 40.523,0 35,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2974" /></g><g
           id="g2976"
           transform="translate(85.7852,463.6416)"><path
             d="M 0,0 C 1.562,-1.748 10.193,-11.741 8.935,-26.254 7.998,-37.06 2.117,-44.154 0,-46.486"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2978" /></g><g
           id="g2980"
           transform="translate(293.7031,320.8252)"><path
             d="M 0,0 H 122.594"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2982" /></g><g
           id="g2984"
           transform="translate(293.7031,275.8252)"><path
             d="M 0,0 H 122.594"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2986" /></g><g
           id="g2988"
           transform="translate(293.7031,230.8252)"><path
             d="M 0,0 H 122.594"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2990" /></g><g
           id="g2992"
           transform="translate(293.7031,185.8252)"><path
             d="M 0,0 H 122.594"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2994" /></g><g
           id="g2996"
           transform="translate(293.7031,140.8252)"><path
             d="M 0,0 H 122.594"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2998" /></g><g
           id="g3000"
           transform="translate(95.7031,320.8252)"><path
             d="M 0,0 H 122.594"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3002" /></g><g
           id="g3004"
           transform="translate(95.7031,275.8252)"><path
             d="M 0,0 H 122.594"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3006" /></g><g
           id="g3008"
           transform="translate(95.7031,230.8252)"><path
             d="M 0,0 H 122.594"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3010" /></g><g
           id="g3012"
           transform="translate(95.7031,185.8252)"><path
             d="M 0,0 H 122.594"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3014" /></g><g
           id="g3016"
           transform="translate(95.7031,140.8252)"><path
             d="M 0,0 H 122.594"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3018" /></g></g></g></g></svg>
</template>
